import { Link } from "@components/Link";
import { Loading } from "@components/Loading";
import { useEvent } from "@helpers/useEvent";
import { useTranslation } from "@helpers/useTranslation";
import { useEffect } from "react";
import { useHasNoPin } from "src/helpers/useHasNoPin";

export const Teams = () => {
  const { t } = useTranslation("teams");
  useHasNoPin();
  const [event, loadingEvent, errorEvent] = useEvent();

  useEffect(() => {
    if (errorEvent) console.error(errorEvent);
  }, [errorEvent]);

  const isPlayers = event?.mainConfig?.playersOnly ?? false;

  const title = isPlayers ? t("titlePlayers") : t("title");
  const about = t("about");
  const dontHaveTeamYet = isPlayers ? t("dontHavePlayerYet") : t("dontHaveTeamYet");
  const createTeam = isPlayers ? t("createPlayer") : t("createTeam");
  const alreadyHaveTeam = isPlayers ? t("alreadyHavePlayer") : t("alreadyHaveTeam");

  return (
    <main className="flex-1 flex-col">
      <Loading loading={!event || loadingEvent}>
        <div className="flex flex-col px-6 py-4">
          <div>
            <h1 className="mt-12 mb-8 text-center  text-4xl font-semibold">{title}</h1>
            <h3 className="mt-8 mb-8 text-center text-xl font-semibold">{about}</h3>
          </div>
          <div className="text-light mt-16 mb-8 text-center text-lg">{dontHaveTeamYet}</div>
          <div className="mt-16 flex justify-center">
            <Link to="newteam">
              <button className="btn-primary btn mb-4 px-4">{createTeam}</button>
            </Link>
          </div>
          <div className="mt-4 flex justify-center text-sm text-neutral dark:text-slate-400">
            <Link to="selectteam">
              <div className="text-neutral underline">{alreadyHaveTeam}</div>
            </Link>
          </div>
        </div>
      </Loading>
    </main>
  );
};
